import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=b790a886&scoped=true&"
import script from "./Diamond.vue?vue&type=script&lang=js&"
export * from "./Diamond.vue?vue&type=script&lang=js&"
import style0 from "./Diamond.vue?vue&type=style&index=0&id=b790a886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b790a886",
  null
  
)

export default component.exports